import { isValidArray } from '../isValidArray';

const TARGET_TAG_KEY = 'free_shipping';

export const checkProductCardShowMkplSection = (productInfo: ProductType, activityTagLimit = null) => {
  const { vender_info_view, product_tag_list } = productInfo ?? {};
  const { eta_range, delivery_desc, free_delivery_desc } = vender_info_view ?? {};

  const getShipsFromText = () => {
    if (!isValidArray(product_tag_list)) return delivery_desc;
    const freeShippingIndex = product_tag_list?.findIndex(item => item.tag_key === TARGET_TAG_KEY);
    // 有且展示了
    if (freeShippingIndex > -1 && (!activityTagLimit || freeShippingIndex + 1 <= activityTagLimit)) {
      return delivery_desc;
    }
    // 有但是没有展示
    if (freeShippingIndex > -1 && freeShippingIndex + 1 > activityTagLimit) {
      return free_delivery_desc;
    }
    return delivery_desc;
  };

  return {
    showEta: !!eta_range,
    etaText: eta_range, // ETA文本
    showShipsFrom: !!getShipsFromText(),
    shipsFromText: getShipsFromText()
  };
};

export default checkProductCardShowMkplSection;
